import { TeamRole } from '@this+that/models';

import { TEAM_FEATURES } from './features';

export const DEFAULT_OWNER_FEATURES = [TEAM_FEATURES.FULL];

export const DEFAULT_ADMIN_FEATURES = [TEAM_FEATURES.FULL];

export const DEFAULT_MEMBER_FEATURES = [TEAM_FEATURES.LIST, TEAM_FEATURES.SHOW];

export const DEFAULT_VIEWER_FEATURES = [TEAM_FEATURES.LIST, TEAM_FEATURES.SHOW];

export const featuresForRole = (role?: TeamRole): string[] => {
  switch (role) {
    case TeamRole.OWNER:
      return DEFAULT_OWNER_FEATURES;
    case TeamRole.ADMIN:
    case TeamRole.CONSULTANT:
      return DEFAULT_ADMIN_FEATURES;
    case TeamRole.VIEWER:
      return DEFAULT_VIEWER_FEATURES;
    default:
      return DEFAULT_MEMBER_FEATURES;
  }
};
